import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FiArrowLeft, FiMail } from 'react-icons/fi';
import { FaCheckCircle } from 'react-icons/fa';
import { Title, SubTitle, Input, Button, IconWrapper, Header, BackButton, } from './withEmail.styles';
import { Container, FormContainer } from '../login.styles';
import { sendOtp } from '../../../services/api/OnboardingServices';
import { isValidEmail } from '../../../utils/helpers/functions';
import { useLoadingActions } from '../../../context&providers/providers/Loading';
import { StatusCodes, StatusMessages } from '../../../utils/enums/StatusCode';
import VerifyOtp from '../verifyOtp';
var WithEmailLoginForm = function (_a) {
    var onClose = _a.onClose;
    var _b = useState(1), step = _b[0], setStep = _b[1];
    var _c = useState(''), email = _c[0], setEmail = _c[1];
    var _d = useState(false), validEmail = _d[0], setValidEmail = _d[1];
    var _e = useState(''), statusMessage = _e[0], setStatusMessage = _e[1];
    var _f = useState(null), statusCode = _f[0], setStatusCode = _f[1];
    var _g = useLoadingActions(), showLoading = _g.showLoading, hideLoading = _g.hideLoading;
    var handleNextStep = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, statusCode_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(step === 1 && email && isValidEmail(email))) return [3 /*break*/, 2];
                    showLoading();
                    return [4 /*yield*/, sendOtp(email)];
                case 1:
                    res = _a.sent();
                    hideLoading();
                    statusCode_1 = res.data.statusCode;
                    // Use statusCode to set the message and proceed accordingly
                    if (statusCode_1 === StatusCodes.OTP_SENT) {
                        setStatusMessage(StatusMessages[statusCode_1]);
                        setStatusCode(statusCode_1);
                        setStep(2); // Transition to OTP input step
                    }
                    else if (statusCode_1 === StatusCodes.VERIFICATION_EMAIL_SENT) {
                        setStatusMessage(StatusMessages[statusCode_1]);
                        setStatusCode(statusCode_1);
                        setStep(3); // Show verification email sent message
                    }
                    else if (statusCode_1 === StatusCodes.VERIFICATION_EMAIL_RESENT) {
                        setStatusMessage(StatusMessages[statusCode_1]);
                        setStatusCode(statusCode_1);
                        setStep(3); // Show verification email resent message
                    }
                    else {
                        setStatusMessage(StatusMessages[StatusCodes.ERROR]);
                        setStatusCode(StatusCodes.ERROR);
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    hideLoading();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = function (e) {
        setEmail(e.target.value);
    };
    var handleBack = function () {
        if (step === 1) {
            onClose(); // Close modal if on step 1
        }
        else {
            setStep(1); // Navigate back to step 1
        }
    };
    useEffect(function () {
        email.length > 0 && setValidEmail(isValidEmail(email));
    }, [email]);
    return (_jsx(Container, { children: _jsxs(FormContainer, { children: [_jsxs(Header, { children: [_jsx(BackButton, { onClick: handleBack, children: _jsx(FiArrowLeft, { size: 20 }) }), _jsx(Title, { children: step === 1 ? 'Continue with email' : 'Check your email' })] }), step === 1 && (_jsxs(_Fragment, { children: [_jsx(SubTitle, { children: "We\u2019ll check if you have an account and help create one if you don\u2019t." }), _jsx(Input, { type: "email", placeholder: "Email (personal or work)", value: email, onChange: handleInputChange }), _jsxs(Button, { onClick: handleNextStep, disabled: !validEmail, children: [_jsx(FiMail, { size: 20 }), "Continue"] })] })), step === 2 && _jsx(VerifyOtp, { setStep: setStep, email: email }), step === 3 && (_jsxs(_Fragment, { children: [_jsx(IconWrapper, { children: _jsx(FaCheckCircle, { size: 40, color: "#6c63ff" }) }), _jsx(Title, { children: statusCode === StatusCodes.VERIFICATION_EMAIL_SENT ? 'Verification email sent' : 'Verification email resent' }), _jsx(SubTitle, { children: statusMessage }), _jsx(Button, { onClick: onClose, children: "Proceed" })] })), step === 4 && (_jsxs(_Fragment, { children: [_jsx(Title, { children: "OTP Verified Successfully" }), _jsx(SubTitle, { children: "You can now proceed to complete your profile or return to the home page." }), _jsx(Button, { onClick: onClose, children: "Go to Profile" })] }))] }) }));
};
export default WithEmailLoginForm;
